import axios from "axios";
import AppEnvService from "../../app/AppEnvService";
import { UnauthorizedF } from "../../app/useUnauthorized";
import AppInitSingletonBo from "../init/AppInitSingletonBo";
import StvLogLevel from "../log/dto/StvLogLevel";
//import CryptoJS from "crypto-js";

let handleUnauthorized: UnauthorizedF;

function setUnauthorizedFunction(newF: UnauthorizedF) {
  handleUnauthorized = newF;
}

//function encrypt(data: object) {
//
//  const secretKey = "your1secret1key1";
//
//  let iv = CryptoJS.enc.Utf8.parse("0000000000000000");
//  //let text = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
//
//  var encryted = CryptoJS.AES.encrypt(
//    JSON.stringify(data),
//    secretKey,
//    {
//        mode: CryptoJS.mode.CBC,
//        padding: CryptoJS.pad.NoPadding,
//        iv: iv}
//  );
//
//  const encryptedData = encryted.toString();
//  return encryptedData;
//}

// Quelle:
// https://www.npmjs.com/package/axios

// axios security instance
const axiosSec = axios.create();

// Add uiSessionId to all requests
axiosSec.interceptors.request.use((reqCfg) => {
  reqCfg.params["uiSessionId"] = AppInitSingletonBo.uiSessionId;

  return reqCfg;
});

// Important: response interceptors **must** return the response.
axiosSec.interceptors.response.use(
  (resp) => resp,
  (error) => {
    if (error.response.status === 401) {
      console.log("interceptors - Unauthorized");

      if (handleUnauthorized) {
        handleUnauthorized();
      }

      throw new Error(`Unauthorized`);
    }
    throw error;
  }
);

const BACKEND_SERVICE_URL = AppEnvService.REACT_APP_BACKEND_SERVICE_URL;

const JSON_HEADERS = {
  Accept: "application/json;charset=utf-8",
  "Content-Type": "application/json;charset=utf-8",
};

// **** Operations ***
function postData(path: string, newParams: any, data?: any) {
  const params = addTimeStampParam(newParams);
  removeBlankAttribute(params);

  const url = `${BACKEND_SERVICE_URL}${path}`;
  const postData = data ? data : {};
  //const postData = data ? { data: data } : {};

  return axiosSec
    .post(url, postData, {
      headers: JSON_HEADERS,
      params: params,
    })
    .then((response) => response.data)
    .catch((error) => {
      postLogData(StvLogLevel.ERROR, `path [${path}]`, error);
      throw error;
    });
}

function postLogData(level: StvLogLevel, message: string, newEx?: any) {
  const msg = newEx
    ? message + " " + newEx + " " + JSON.stringify(newEx)
    : message;
  const newParams = {};
  const params = addTimeStampParam(newParams);

  const url = `${BACKEND_SERVICE_URL}rest/op/log`;

  const postData = {
    level,
    message: msg,
  };

  return axiosSec
    .post(url, postData, {
      headers: JSON_HEADERS,
      params: params,
    })
    .then((response) => response.data)
    .catch((error) => {
      // do nothing - Endlosschleife meiden
    });
}

function putData(path: string, newParams: any, data: any) {
  const params = addTimeStampParam(newParams);
  removeBlankAttribute(params);

  const url = `${BACKEND_SERVICE_URL}${path}`;
  const postData = data ? data : {};
  return axiosSec
    .put(url, postData, {
      headers: JSON_HEADERS,
      params: params,
    })
    .then((response) => response.data)
    .catch((error) => {
      postLogData(StvLogLevel.ERROR, `path [${path}]`, error);
      throw error;
    });
}

function getData(path: string, newParams: any) {
  const params = addTimeStampParam(newParams);
  removeBlankAttribute(params);

  const url = `${BACKEND_SERVICE_URL}${path}`;
  return axiosSec
    .get(url, {
      headers: JSON_HEADERS,
      params: params,
    })
    .then((response) => response.data)
    .catch((error) => {
      postLogData(StvLogLevel.ERROR, `path [${path}]`, error);
      throw error;
    });
}

function deleteData(path: string, newParams: any) {
  const params = addTimeStampParam(newParams);
  removeBlankAttribute(params);

  const url = `${BACKEND_SERVICE_URL}${path}`;
  return axiosSec
    .delete(url, {
      headers: JSON_HEADERS,
      params: params,
    })
    .then((response) => response.data)
    .catch((error) => {
      postLogData(StvLogLevel.ERROR, `path [${path}]`, error);
      throw error;
    });
}

function removeBlankAttribute(object: any) {
  for (var key in object) {
    if (
      object[key] === null ||
      object[key] === undefined ||
      (typeof object[key] === "string" && object[key].length === 0)
    ) {
      delete object[key];
    }
  }
}

function addTimeStampParam(params: any) {
  const result = {
    ...params,
    timestamp: new Date().getTime(),
  };
  return result;
}

const BackendService = {
  getData,
  postData,
  postLogData,
  putData,
  deleteData,
  setUnauthorizedFunction,
};

export default BackendService;
